import { IS_DEV } from '@constants';

export default {
  isShowComponentLibrary: IS_DEV,
  locale: true,
  routerType: true // 权限类型
};
